import * as actions from './stationSearchActionsConstants';

import {
  stationSearch,
  ORIGIN_KEY,
  DESTINATION_KEY
} from '../api/stationSearchAPI';

let currentSearchIndex = 0;
let lastCompletedSearchIndex = 0;

function search(key, query, includePseudoCities, recommendedStations, originSelections, destinationSelections, dispatch) {
  dispatch({ type: actions.STATION_SEARCH_REQUEST, query })

  let searchIndex = ++currentSearchIndex;

  return stationSearch(query, includePseudoCities, recommendedStations, originSelections, destinationSelections)
    .then(
      data => {
        if (searchIndex < lastCompletedSearchIndex) return;
        lastCompletedSearchIndex = searchIndex;
        return dispatch({ type: actions.STATION_SEARCH_SUCCESS, stations: data });
      },
      error => {
        if (searchIndex < lastCompletedSearchIndex) return;
        lastCompletedSearchIndex = searchIndex;
        return dispatch({ type: actions.STATION_SEARCH_ERROR });
      }
    );
}

export function searchOrigins(query, includePseudoCities, recommendedStations, destinationSelections) {
  return function(dispatch) {
    return search(ORIGIN_KEY, query, includePseudoCities, recommendedStations, null, destinationSelections, dispatch);
  }
}

export function searchDestinations(query, includePseudoCities, recommendedStations, originSelections) {
  return function(dispatch) {
    return search(DESTINATION_KEY, query, includePseudoCities, recommendedStations, originSelections, null, dispatch);
  }
}

export function clearStationSearch() {
  return { type: actions.STATION_SEARCH_CLEAR };
}

export function loadSuggested() {
  return function(dispatch) {
    return fetch(
      '/station_search/suggested'
    ).
    then(response => response.json()).
    then(data => {
      dispatch({
        type: actions.LOAD_SUGGESTED_STATIONS_SUCCESS,
        data: data
      });
    });
  }
}

export function loadRecent() {
  return function(dispatch) {
    return fetch(
      '/recent_flight_searches',
      {
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin'
      }
    ).
    then(response => response.json()).
    then(data => {
      dispatch({
        type: actions.LOAD_RECENT_STATIONS_SUCCESS,
        data: data
      });
    });
  }
}